import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Guadeloupe: Country = {
    identifier: "Guadeloupe",
    name: "Guadeloupe",
    countryCode: "GP",
    group: CountryGroup.NORTH_AMERICA,
    isUNMember: false,
    flag: "🇬🇵",
    svgPath: "m 302.78075,417.0504 -0.33,0.032 -0.217,-0.025 -0.05,-0.208 0.111,-0.176 -0.08,-0.214 0.051,-0.127 0.111,-0.084 0.182,0.112 0.029,0.16 0.114,0.146 0.513,0.312 -0.434,0.072 z m -0.736,0.649 -0.227,0.13 -0.111,-0.04 -0.138,-0.25 -0.097,-0.694 0.075,-0.115 0.054,-0.043 0.299,0.085 0.125,0.098 0.125,0.062 -0.063,0.127 0.031,0.521 -0.073,0.119 z m 1.008,0.34 -0.156,0.011 -0.069,-0.025 -0.021,-0.174 0.121,-0.12 0.071,-0.029 0.105,0.135 0.025,0.112 -0.076,0.09 z",
}
